import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { Filter, SensorDataFileValueFilter } from "@shared/interfaces";

export default {
  getSensorDataFiles: (payload: Filter) => {
    return request(METHODS.GET, API.SENSOR_DATA_FILE.GET_SENSOR_DATA_FILES)({ params: payload });
  },
  getSensorDataFileValues: (payload: SensorDataFileValueFilter & { id: number }) => {
    const { id, ...filter } = payload;
    return request(METHODS.GET, API.SENSOR_DATA_FILE.GET_SENSOR_DATA_FILE_VALUES(String(id)))({ params: filter });
  },

  getSensorDataFile: (payload: { id: number }) => {
    const { id } = payload;
    return request(METHODS.GET, API.SENSOR_DATA_FILE.GET_SENSOR_DATA_FILE(String(id)))();
  },
  createSensorDataFile: (payload: FormData, onUploadProgress: (p: { loaded: number; total: number }) => void) =>
    request(METHODS.POST, API.SENSOR_DATA_FILE.GET_SENSOR_DATA_FILES)(payload, {
      onUploadProgress,
    }),
};
